import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import interfaceSettings from './modules/interface.module'
import user from './modules/user.module'
import company from './modules/company.module'
import game from './modules/game.module'
import Config from '../config'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const storage = Config.debug ? window.sessionStorage : window.localStorage

export default new Vuex.Store({
  modules: {
    interfaceSettings,
    user,
    company,
    game
  },
  strict: debug,
  plugins: [createPersistedState({
    key: 'vuex-player-bg',
    paths: ['interfaceSettings', 'user', 'game', 'company'],
    storage: storage
  })]
})